import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  sortHighToLow: 'Sort High to Low',
  sortLowToHigh: 'Sort Low to High',
})
